import { graphql, useStaticQuery } from 'gatsby';

// Reusable hook for accessing national offer
export const useCareersHeader = () => {
	const data = useStaticQuery(
		graphql`
			query {
				contentstackCareersHeader {
					ctas {
						...CTA
					}
					navigation {
						menu_items {
							menu_heading
							ctas {
								...CTA
							}
							dropdown {
								image {
									...Image
									image {
										gatsbyImageData(layout: FULL_WIDTH, quality: 90)
									}
								}
								heading
								description
								ctas {
									...CTA
								}
							}
						}
					}
				}
			}
		`
	);

	return data.contentstackCareersHeader;
};
